<template>
	<v-container fluid class="fill-height">
		<v-row justify="center" class="pa-2">
				<v-card class="elevation-12 custom_card" max-width="500" >
					<v-toolbar class="custom_toolbar blue-grey darken-4" dark flat>
						<v-row justify="center">
							<v-toolbar-title class="display-1">{{ $t("header.title") }}</v-toolbar-title>
						</v-row>
					</v-toolbar>
					
					<v-card-text>
						<v-container fluid>
							<v-form>
								<v-row dense>
									<v-col cols="12" class="text-center">
										<h3 class="custom_header" v-html="title"></h3>
									</v-col>
									
									<slot name="formFields"></slot>
								
								</v-row>
							</v-form>
						</v-container>
					</v-card-text>
					
					<v-card-actions>
						<v-container fluid>
							<v-row dense>
								<v-col cols="12" class="text-center submit_btn_col">
									<v-btn @click="submit" color="primary">{{ buttonLabel }}</v-btn>
								</v-col>
								
								<slot name="forgotPasswordLink"></slot>

							</v-row>
						</v-container>
					</v-card-actions>

					<v-footer color="grey lighten-4">
						<v-img :src="require('../assets/logo_bluchip.png')" max-width="100" class="mt-1"></v-img>
						<v-spacer></v-spacer>
						<div>v {{ version }}</div>
					</v-footer>
				</v-card>
		</v-row>
	</v-container>
</template>

<script>
    export default {
        name: 'AuthForm',
        props: {
            title: String,
            buttonLabel: {
                type: String,
                default: 'Submit'
            }
        },
        data: () => ({
			version: process.env.VUE_APP_VERSION
		}),
        computed: {},
        methods: {
            submit() {
                this.$emit('submit');
            }
        },
    }
</script>
